var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_5002",
    "data-name": "Groupe 5002",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.265,
    height: 36.711,
    viewBox: "0 0 32.265 36.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5142",
    "data-name": "Trac\\xE9 5142",
    d: "M20.435,0h-8.6A3.23,3.23,0,0,0,8.6,3.227V4.3H3.227a3.226,3.226,0,0,0-1,6.293L4.141,33.752a3.245,3.245,0,0,0,3.215,2.959H24.909a3.246,3.246,0,0,0,3.215-2.959l1.918-23.157a3.226,3.226,0,0,0-1-6.292H23.661V3.227A3.23,3.23,0,0,0,20.435,0m-9.68,3.227a1.077,1.077,0,0,1,1.076-1.076h8.6A1.077,1.077,0,0,1,21.51,3.227V4.3H10.755ZM25.98,33.574a1.082,1.082,0,0,1-1.072.986H7.357a1.082,1.082,0,0,1-1.072-.986L4.395,10.755H27.871ZM30.114,7.529A1.077,1.077,0,0,1,29.039,8.6H3.227a1.076,1.076,0,0,1,0-2.151H29.039a1.077,1.077,0,0,1,1.076,1.076",
    fill: "#ff2a2a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5143",
    "data-name": "Trac\\xE9 5143",
    d: "M121.076,198.492a1.076,1.076,0,1,0,2.147-.133l-1.076-17.352a1.076,1.076,0,0,0-2.147.133Z",
    transform: "translate(-111.395 -167.092)",
    fill: "#ff2a2a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5144",
    "data-name": "Trac\\xE9 5144",
    d: "M211.076,199.5a1.076,1.076,0,0,0,1.076-1.076V181.076a1.076,1.076,0,1,0-2.151,0v17.352a1.076,1.076,0,0,0,1.076,1.076",
    transform: "translate(-194.943 -167.094)",
    fill: "#ff2a2a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5145",
    "data-name": "Trac\\xE9 5145",
    d: "M286.008,199.5a1.075,1.075,0,0,0,1.14-1.007l1.076-17.352a1.076,1.076,0,0,0-2.147-.133L285,198.36a1.076,1.076,0,0,0,1.007,1.14",
    transform: "translate(-264.564 -167.093)",
    fill: "#ff2a2a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/red-trash.347747bcfe19cf6421f8d0195ea36994.svg";
export { ForwardRef as ReactComponent };